export default __webpack_public_path__ + "static/media/blackwire.1f1e5ef8.jpg";